import React, { Suspense, lazy } from "react";
import { useCurrentCompany } from "hooks/auth";
import { CurrentAccountType, useProfileContext } from "newui/features/Auth/context/ProfileContext";
import { LoadingSpinner } from "components/Loading/LoadingSpinner";

const PdfSettingsLazy = lazy(() =>
	import("./PdfSettings/PdfSettings").then((m) => ({ default: m.PdfSettings }))
);

interface PdfSettingsPageProps {
	path?: string;
}

export const PdfSettingsPage: React.FC<PdfSettingsPageProps> = () => {
	const company = useCurrentCompany();
	const profileContext = useProfileContext();
	const accountType = profileContext?.currentProfile === CurrentAccountType.PROCURER ? "procurer" : "supplier";

	if (!company) {
		return <LoadingSpinner label="Loading..." verticalPadding={8} />;
	}

	return (
		<Suspense
			fallback={
				<LoadingSpinner label="Loading PDF Report Settings..." verticalPadding={8} />
			}
		>
			<PdfSettingsLazy companyId={company.id} accountType={accountType} />
		</Suspense>
	);
};
